import $ from "jquery";
import _ from "underscore";
import Packery from "packery";
import imagesLoaded from "imagesloaded";
import StateManager from "../scuba/StateManager";

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function (event, node) {
  $(node)
    .find(".js-gallery")
    .each(function (i, el) {
      new Gallery(el);
    });
});

/* --------------------------------------------------

    CLASS

-------------------------------------------------- */

function Gallery() {
  this.initialize.apply(this, arguments);
}

$.extend(Gallery.prototype, {
  initialize: function (el) {
    var self = this;
    self.uid = _.uniqueId("scuba-");
    self.$el = $(el);
    self.$sectionContent = self.$el.closest(".js-scuba__content");
    self.packery = new Packery(el, {
      itemSelector: ".js-gallery__image",
      transitionDuration: 0,
      percentPosition: true,
      gutter: 0,
    });

    self.$sectionContent.on("widthChanged", self.relayout.bind(self));

    imagesLoaded(el).on("progress", self.relayout.bind(self));
  },

  relayout: function () {
    var self = this;
    self.packery.layout();
  },
});



// WEBPACK FOOTER //
// ./scripts/components/Gallery.js